import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1307bba7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Whatsapp" }
const _hoisted_2 = { class: "mt-3 flex items-center justify-end" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download mr-2" }, null, -1))
const _hoisted_4 = { class: "mt-4 bg-white rounded" }
const _hoisted_5 = { class: "flex items-center justify-end py-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog" }, null, -1))
const _hoisted_7 = { class: "WhatsappTable" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col items-center justify-center text-sm text-gray-400 select-none"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Загрузка списка...", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении списка произошла ошибка", -1))
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 1,
  class: "WhatsappTable"
}
const _hoisted_13 = { class: "flex items-center justify-end pb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_button = _resolveComponent("new-button")!
  const _component_CrmWhatsappFilters = _resolveComponent("CrmWhatsappFilters")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_loader = _resolveComponent("loader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_new_button, {
        onClick: _ctx.exportExcel,
        loading: _ctx.state.is_loading,
        class: "NewButton--secondary"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Скачать Excel ")
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    _createVNode(_component_CrmWhatsappFilters, {
      class: "mt-3",
      loading: _ctx.state.is_loading,
      disabled: _ctx.state.is_loading,
      onSubmit: _ctx.onFiltersChanged,
      onReset: _ctx.onFiltersReset
    }, null, 8, ["loading", "disabled", "onSubmit", "onReset"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_new_button, {
          class: "NewButton--search mr-3",
          loading: _ctx.state.is_loading,
          disabled: !_ctx.state.list.length,
          onClick: _ctx.tablesStore.toggleModal
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"]),
        _createVNode(_component_new_limit, {
          disabled: _ctx.state.is_loading,
          value: _ctx.state.pagination.limit,
          "total-items": _ctx.state.pagination.total_items,
          onChange: _ctx.onLimitChange
        }, null, 8, ["disabled", "value", "total-items", "onChange"]),
        _createVNode(_component_new_pagination, {
          class: "ml-6",
          disabled: _ctx.state.is_loading,
          "current-page": _ctx.state.pagination.page,
          "total-pages": _ctx.state.pagination.total_pages,
          onChangePage: _ctx.onChangePage
        }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.state.is_loading || _ctx.state.is_failed || _ctx.state.list.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_ctx.state.is_loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_loader, { class: "primary" }),
                    _hoisted_9
                  ], 64))
                : (_ctx.state.is_failed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_10,
                      _createVNode(_component_new_button, {
                        class: "mt-1",
                        onClick: _ctx.loadHistory
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Перезагрузить ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : (_ctx.state.list.length === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Список пуст"))
                    : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_new_table, {
                columns: _ctx.TABLE_COLUMNS,
                rows: _ctx.state.list
              }, {
                td: _withCtx(({ column, row }) => [
                  (column.key === 'phone')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "text-blue-500",
                        to: `/amo-crm/whatsapp/${row.chat_id}`,
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row[column.key]), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (column.key === 'message')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.cut(row[column.key], 30)), 1)
                        ], 64))
                      : (column.key === 'sendedAt')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(_ctx.formatDate(row[column.key])), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createTextVNode(_toDisplayString(row[column.key]), 1)
                          ], 64))
                ]),
                _: 1
              }, 8, ["columns", "rows"])
            ]))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_new_limit, {
          disabled: _ctx.state.is_loading,
          value: _ctx.state.pagination.limit,
          "total-items": _ctx.state.pagination.total_items,
          onChange: _ctx.onLimitChange
        }, null, 8, ["disabled", "value", "total-items", "onChange"]),
        _createVNode(_component_new_pagination, {
          class: "ml-6",
          disabled: _ctx.state.is_loading,
          "current-page": _ctx.state.pagination.page,
          "total-pages": _ctx.state.pagination.total_pages,
          onChangePage: _ctx.onChangePage
        }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
      ])
    ])
  ]))
}